import React from "react"
import {
  background,
  backgroundText,
  backgroundWithoutBanner,
} from "../header.module.scss"
import ImageFromDrupal from "gatsby-theme-blank/src/components/Image/image-from-drupal"
import { BackgroundText } from "../header-styled"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import PropTypes from "prop-types"

const Banner = ({ isIndex }) => {
  const buildInfos = useBuildData().site_settings
  if (!isIndex) {
    return null
  }
  let bannerHtml = undefined
  if (buildInfos.header_banner.fid) {
    bannerHtml = (
      <div className={background}>
        <ImageFromDrupal
          alt={"Banniere " + buildInfos.website_name}
          drupal_fid={buildInfos.header_banner.fid}
        />
        <BackgroundText className={backgroundText}>
          <p>{buildInfos.website_name}</p>
        </BackgroundText>
      </div>
    )
  } else if (buildInfos.website_name) {
    bannerHtml = (
      <div className={backgroundWithoutBanner}>
        <BackgroundText className={backgroundText}>
          <p>{buildInfos.website_name}</p>
        </BackgroundText>
      </div>
    )
  }
  return <>{bannerHtml}</>
}

Banner.propTypes = {
  isIndex: PropTypes.bool,
}

export default Banner
